module.exports = __webpack_public_path__ + "img/gold3.cabe13aa.png";